(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  function initRecommendations() {
    const productRecommendationsSection = document.querySelector('.product-recommendations');
    if (!productRecommendationsSection) return;

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(productRecommendationsSection);
      const url = productRecommendationsSection.dataset.url;
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length > 0) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => console.error(e));
    };

    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);
  }

  function initShippingInterceptor() {
    // Interceptar quando o cálculo do frete atualiza para atualizar dinamicamente o resumo
    document.body.addEventListener('submit', function(event) {
      const form = event.target.closest('[data-shipping-form]');
      if (!form) return;
      
      const ratesList = form.querySelector('[data-shipping-rates]');
      if (!ratesList) return;
      
      const observer = new MutationObserver(() => {
        const firstRatePrice = ratesList.querySelector('.shipping-calculator__price');
        const summaryShippingCost = document.querySelector('[data-cart-shipping-cost]');
        if (firstRatePrice && summaryShippingCost) {
          summaryShippingCost.textContent = firstRatePrice.textContent;
          
          // Recalcular o valor total no resumo
          const subtotalText = document.querySelector('[data-cart-subtotal]');
          const totalText = document.querySelector('[data-cart-total]');
          if (subtotalText && totalText) {
            const subtotalCents = parseInt(subtotalText.textContent.replace(/\D/g, ''), 10);
            const shippingText = firstRatePrice.textContent.trim().toLowerCase();
            let shippingCents = 0;
            if (shippingText !== 'grátis' && shippingText !== 'gratis') {
              shippingCents = parseInt(shippingText.replace(/\D/g, ''), 10);
            }
            
            const totalCents = subtotalCents + shippingCents;
            const formattedTotal = (totalCents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            totalText.textContent = formattedTotal;
            
            // Atualizar parcelas
            const installmentsWrapper = document.querySelector('[data-cart-installments]');
            if (installmentsWrapper) {
              const installmentsCount = parseInt(installmentsWrapper.dataset.installments || 3, 10);
              const installmentVal = totalCents / installmentsCount / 100;
              const formattedInstallment = installmentVal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
              installmentsWrapper.textContent = `ou até ${installmentsCount}x de ${formattedInstallment} sem juros`;
            }
          }
        }
      });
      
      observer.observe(ratesList, { childList: true, subtree: true });
    });
  }

  window.initCartPage = function() {
    initRecommendations();
    initShippingInterceptor();
  };

  document.addEventListener('DOMContentLoaded', function() {
    window.initCartPage();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
    window.addEventListener('popstate', this.onPopState.bind(this));
  }

  onClick(event) {
    const chip = event.target.closest('.collection-toolbar__chip');
    if (chip) {
      event.preventDefault();
      this.fetchPage(chip.getAttribute('href'));
    }
  }
  
  onPopState(event) {
    this.fetchPage(window.location.pathname + window.location.search, false);
  }

  async fetchPage(url, updateHistory = true) {
    this.classList.add('is-loading');

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network error');
      
      const htmlText = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');

      // Update the main container (Title, Toolbar, Grid)
      const newFilters = doc.querySelector('collection-filters');
      if (newFilters) {
        this.innerHTML = newFilters.innerHTML;
      }

      // Update Banner if it exists
      const newBanner = doc.querySelector('.collection-banner');
      const currentBanner = document.querySelector('.collection-banner');
      if (newBanner && currentBanner) {
        currentBanner.innerHTML = newBanner.innerHTML;
      }

      // Update Page Title
      if (doc.title) {
        document.title = doc.title;
      }

      if (updateHistory) {
        history.pushState({ url }, '', url);
      }
    } catch (error) {
      console.error('Error fetching filtered page:', error);
      window.location.href = url; // Fallback to normal navigation
    } finally {
      this.classList.remove('is-loading');
    }
  }
}

if (!customElements.get('collection-filters')) {
  customElements.define('collection-filters', CollectionFilters);
}

class CustomSelect extends HTMLElement {
  constructor() {
    super();
    this.display = this.querySelector('.collection-toolbar__select');
    this.valueText = this.querySelector('.custom-select__value');
    this.options = this.querySelectorAll('.custom-select__option');
    this.isOpen = false;
    this.paramName = this.dataset.param || 'sort_by';

    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.toggle);
    this.options.forEach(opt => opt.addEventListener('click', this.onOptionClick));
    document.addEventListener('click', this.close);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.toggle);
    this.options.forEach(opt => opt.removeEventListener('click', this.onOptionClick));
    document.removeEventListener('click', this.close);
  }

  toggle(e) {
    if (e.target.closest('.custom-select__option')) return;
    e.stopPropagation();
    this.isOpen = !this.isOpen;
    this.classList.toggle('is-open', this.isOpen);
  }

  close(e) {
    if (this.isOpen && !this.contains(e.target)) {
      this.isOpen = false;
      this.classList.remove('is-open');
    }
  }

  onOptionClick(e) {
    e.stopPropagation();
    const value = e.currentTarget.dataset.value;
    const text = e.currentTarget.textContent;
    
    // Update visuals
    this.valueText.textContent = text;
    this.options.forEach(opt => opt.classList.remove('is-selected'));
    e.currentTarget.classList.add('is-selected');
    
    this.isOpen = false;
    this.classList.remove('is-open');

    // Trigger update
    if (this.paramName === 'sort_by') {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      
      const filters = document.querySelector('collection-filters');
      if (filters && typeof filters.fetchPage === 'function') {
        filters.fetchPage(url.toString());
      } else {
        window.location.href = url.toString();
      }
    }
  }
}

if (!customElements.get('custom-select')) {
  customElements.define('custom-select', CustomSelect);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-account"]) return;
  try {
    
  (function() {
    // Navegação SPA-like
    const navItems = document.querySelectorAll('.ca-nav__item[data-section]');
    const sections = document.querySelectorAll('.ca-section');

    function showSection(id) {
      sections.forEach(s => s.classList.remove('is-active'));
      navItems.forEach(n => n.classList.remove('is-active'));
      const target = document.getElementById('ca-' + id);
      if (target) target.classList.add('is-active');
      navItems.forEach(n => { if (n.dataset.section === id) n.classList.add('is-active'); });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    navItems.forEach(btn => {
      btn.addEventListener('click', () => showSection(btn.dataset.section));
    });

    // Mobile sidebar toggle
    const sidebar = document.getElementById('ca-sidebar');

    const toggleBtn = document.createElement('button');
    toggleBtn.className = 'ca-mobile-toggle';
    toggleBtn.innerHTML = '&#9776;';
    toggleBtn.setAttribute('aria-label', 'Menu');
    document.querySelector('.ca-main').prepend(toggleBtn);

    const overlay = document.createElement('div');
    overlay.className = 'ca-mobile-overlay';
    document.body.appendChild(overlay);

    function openSidebar() {
      sidebar.classList.add('is-open');
      overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }

    function closeSidebar() {
      sidebar.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    toggleBtn.addEventListener('click', openSidebar);
    overlay.addEventListener('click', closeSidebar);

    navItems.forEach(item => {
      item.addEventListener('click', closeSidebar);
    });

    // Estilo inline do mobile toggle e overlay (para não depender do stylesheet que só processa uma vez)
    const style = document.createElement('style');
    style.textContent = `
      .ca-mobile-toggle {
        display: none;
        background: none;
        border: 1px solid var(--color-border);
        border-radius: 8px;
        padding: 0.5rem 0.75rem;
        font-size: 1.25rem;
        cursor: pointer;
        color: var(--color-foreground);
        margin-bottom: 1.5rem;
      }
      .ca-mobile-overlay {
        display: none;
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.3);
        backdrop-filter: blur(4px);
        z-index: 199;
      }
      .ca-mobile-overlay.is-visible { display: block; }
      @media (max-width: 768px) {
        .ca-mobile-toggle { display: flex; }
      }
    `;
    document.head.appendChild(style);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var overlay = document.querySelector('[data-search-overlay]');
    var input = document.querySelector('[data-search-input]');
    var openBtns = document.querySelectorAll('[data-search-open]');
    var closeBtn = document.querySelector('[data-search-close]');

    if (!overlay || !input || openBtns.length === 0 || !closeBtn) return;

    function openSearch() {
      overlay.classList.add('is-active');
      overlay.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        input.focus();
      });
    }

    function closeSearch() {
      overlay.classList.remove('is-active');
      overlay.setAttribute('aria-hidden', 'true');
      input.value = '';
      
      // Focus on the first visible open button
      var visibleBtn = Array.prototype.filter.call(openBtns, function(btn) {
        return btn.offsetWidth > 0 || btn.offsetHeight > 0;
      })[0] || openBtns[0];
      if (visibleBtn) visibleBtn.focus();
    }

    Array.prototype.forEach.call(openBtns, function(btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openSearch();
      });
    });

    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeSearch();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-active')) {
        closeSearch();
        var predictive = document.querySelector('predictive-search');
        if (predictive) predictive.close();
      }
    });

    class PredictiveSearch extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
        this.form = this.querySelector('form');
        this.abortController = new AbortController();

        this.setupEventListeners();
      }

      setupEventListeners() {
        if (!this.input) return;

        this.input.addEventListener('input', this.debounce((event) => {
          this.onChange(event);
        }, 300));
        
        this.input.addEventListener('focus', () => {
          if (this.input.value.trim().length > 0) {
            this.setAttribute('results', 'true');
          }
        });
        
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) {
            this.close();
          }
        });
      }

      onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
          this.close();
          return;
        }

        this.getSearchResults(searchTerm);
      }

      getSearchResults(searchTerm) {
        this.setAttribute('loading', 'true');
        // Previne o "piscar" dos resultados antigos limpando a caixa antes da nova busca
        this.predictiveSearchResults.innerHTML = '<div style="padding: 1.5rem; text-align: center; color: #999; font-size: 0.875rem;">Buscando...</div>';

        this.abortController.abort();
        this.abortController = new AbortController();

        fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product&section_id=predictive-search`, {
          signal: this.abortController.signal
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(response.status);
            }
            return response.text();
          })
          .then((text) => {
            // Insere o HTML diretamente no dropdown para garantir que não haja erros de parser
            this.predictiveSearchResults.innerHTML = text;
            this.setAttribute('results', 'true');
          })
          .catch((error) => {
            if (error.name !== 'AbortError') {
              this.predictiveSearchResults.innerHTML = '<div style="padding:1rem; color:red;">Erro ao buscar resultados.</div>';
              this.setAttribute('results', 'true');
            }
          })
          .finally(() => {
            this.removeAttribute('loading');
          });
      }

      close() {
        this.removeAttribute('results');
      }

      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }

    if (!customElements.get('predictive-search')) {
      customElements.define('predictive-search', PredictiveSearch);
    }

    // ── Mega Menu Logic ──
    var megaTriggers = document.querySelectorAll('[data-mega-menu-trigger]');

    megaTriggers.forEach(function (trigger) {
      var menu = trigger.querySelector('[data-mega-menu]');
      var link = trigger.querySelector('.site-header__nav-link');
      var timeoutId;

      if (!menu) return;

      function openMenu() {
        clearTimeout(timeoutId);
        menu.classList.add('is-active');
        menu.setAttribute('aria-hidden', 'false');
        if (link) link.setAttribute('aria-expanded', 'true');
      }

      function closeMenu() {
        timeoutId = setTimeout(function () {
          menu.classList.remove('is-active');
          menu.setAttribute('aria-hidden', 'true');
          if (link) link.setAttribute('aria-expanded', 'false');
        }, 150);
      }

      trigger.addEventListener('mouseenter', openMenu);
      trigger.addEventListener('mouseleave', closeMenu);

      if (link) {
        link.addEventListener('focus', openMenu);
      }

      menu.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeMenu();
          if (link) link.focus();
        }
      });

      trigger.addEventListener('focusout', function (e) {
        if (!trigger.contains(e.relatedTarget)) {
          closeMenu();
        }
      });
    });

    // ── Mobile Drawer Logic ──
    var mobileOpenBtn = document.querySelector('[data-mobile-menu-open]');
    var mobileCloseBtn = document.querySelector('[data-mobile-menu-close]');
    var mobileDrawer = document.querySelector('[data-mobile-menu-drawer]');
    var mobileOverlay = document.querySelector('[data-mobile-menu-overlay]');

    if (mobileOpenBtn && mobileCloseBtn && mobileDrawer && mobileOverlay) {
      function openMobileMenu() {
        mobileDrawer.classList.add('is-active');
        mobileOverlay.classList.add('is-active');
        mobileDrawer.setAttribute('aria-hidden', 'false');
        mobileOverlay.setAttribute('aria-hidden', 'false');
        mobileOpenBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
      }

      function closeMobileMenu() {
        mobileDrawer.classList.remove('is-active');
        mobileOverlay.classList.remove('is-active');
        mobileDrawer.setAttribute('aria-hidden', 'true');
        mobileOverlay.setAttribute('aria-hidden', 'true');
        mobileOpenBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';

        // Collapse all submenus on close
        var openSubmenus = mobileDrawer.querySelectorAll('.mobile-drawer__submenu');
        openSubmenus.forEach(function(submenu) {
          submenu.style.display = 'none';
          submenu.setAttribute('aria-hidden', 'true');
        });
        var openChevrons = mobileDrawer.querySelectorAll('.icon-chevron');
        openChevrons.forEach(function(chevron) {
          chevron.style.transform = 'rotate(0deg)';
        });
        var openLinks = mobileDrawer.querySelectorAll('.mobile-drawer__link');
        openLinks.forEach(function(link) {
          link.classList.remove('is-open');
        });
        var openToggles = mobileDrawer.querySelectorAll('.mobile-drawer__toggle');
        openToggles.forEach(function(toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        });
      }

      mobileOpenBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openMobileMenu();
      });

      mobileCloseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeMobileMenu();
      });

      mobileOverlay.addEventListener('click', closeMobileMenu);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileDrawer.classList.contains('is-active')) {
          closeMobileMenu();
        }
      });

      // Submenu toggle logic (Accordion)
      var submenuItems = mobileDrawer.querySelectorAll('.mobile-drawer__menu-item.has-submenu');
      submenuItems.forEach(function (item) {
        var link = item.querySelector('.mobile-drawer__link');
        var toggle = item.querySelector('.mobile-drawer__toggle');
        var submenu = item.querySelector('.mobile-drawer__submenu');
        var chevron = item.querySelector('.icon-chevron');

        if (!link || !toggle || !submenu || !chevron) return;

        function toggleSubmenu(e) {
          e.preventDefault();
          var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', !isExpanded);

          if (isExpanded) {
            submenu.style.display = 'none';
            submenu.setAttribute('aria-hidden', 'true');
            chevron.style.transform = 'rotate(0deg)';
            link.classList.remove('is-open');
          } else {
            submenu.style.display = 'flex';
            submenu.setAttribute('aria-hidden', 'false');
            chevron.style.transform = 'rotate(180deg)';
            link.classList.add('is-open');
          }
        }

        link.addEventListener('click', toggleSubmenu);
        toggle.addEventListener('click', toggleSubmenu);
      });
    }

    // Hide header on mobile when footer is in view
    var footer = document.querySelector('footer');
    var headerSection = document.querySelector('.site-header');
    if (footer && headerSection) {
      var sectionContainer = headerSection.closest('.shopify-section');
      if (sectionContainer) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              sectionContainer.classList.add('header--hidden-footer');
            } else {
              sectionContainer.classList.remove('header--hidden-footer');
            }
          });
        }, {
          threshold: 0
        });
        observer.observe(footer);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description-details"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const accordions = document.querySelectorAll('[data-accordion-btn]');
    
    accordions.forEach(btn => {
      btn.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const content = this.nextElementSibling;
        
        // Close all others
        accordions.forEach(otherBtn => {
          if (otherBtn !== this) {
            otherBtn.setAttribute('aria-expanded', 'false');
            otherBtn.nextElementSibling.style.maxHeight = null;
          }
        });
        
        // Toggle current
        this.setAttribute('aria-expanded', !isExpanded);
        
        if (!isExpanded) {
          content.style.maxHeight = content.scrollHeight + "px";
        } else {
          content.style.maxHeight = null;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // 1. Image Gallery Logic
    const thumbnails = document.querySelectorAll('.product-media__thumbnail-btn');
    const mainImages = document.querySelectorAll('.product-media__item');

    thumbnails.forEach(btn => {
      btn.addEventListener('click', function() {
        const mediaId = this.dataset.mediaId;
        const targetImg = document.querySelector(`.product-media__item[data-media-id="${mediaId}"]`);

        if (!targetImg || targetImg.classList.contains('is-active')) return;
        
        thumbnails.forEach(t => t.classList.remove('is-active'));
        mainImages.forEach(img => img.classList.remove('is-active'));
        
        this.classList.add('is-active');
        targetImg.classList.add('is-active');
      });
    });

    // 2. Quantity Logic
    const qtyMinus = document.querySelector('[data-qty-minus]');
    const qtyPlus = document.querySelector('[data-qty-plus]');
    const qtyInput = document.querySelector('[data-qty-input]');

    if(qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', () => {
        let val = parseInt(qtyInput.value, 10);
        if (val > 1) qtyInput.value = val - 1;
      });
      qtyPlus.addEventListener('click', () => {
        let val = parseInt(qtyInput.value, 10);
        let max = parseInt(qtyInput.getAttribute('max'), 10);
        if (!isNaN(max) && val >= max) {
          qtyInput.value = max;
        } else {
          qtyInput.value = val + 1;
        }
      });
      qtyInput.addEventListener('change', () => {
        let val = parseInt(qtyInput.value, 10);
        let max = parseInt(qtyInput.getAttribute('max'), 10);
        if (!isNaN(max) && val > max) {
          qtyInput.value = max;
        }
      });
    }

    // 3. Variant Logic
    const variantRadios = document.querySelectorAll('[data-variant-option]');
    const variantIdInput = document.querySelector('[data-variant-id]');
    const variantsJsonEl = document.querySelector('[data-product-variants-json]');
    const inventoryJsonEl = document.querySelector('[data-product-inventory-json]');
    const addToCartBtn = document.getElementById('product-add-to-cart-btn');
    
    if (variantsJsonEl && variantRadios.length > 0) {
      try {
        const variants = JSON.parse(variantsJsonEl.textContent);
        const inventories = inventoryJsonEl ? JSON.parse(inventoryJsonEl.textContent) : null;
        
        function updateVariantAvailability() {
          const form = document.querySelector('[data-product-form]');
          const checkedRadios = form.querySelectorAll('[data-variant-option]:checked');
          
          const selectedOptions = [];
          checkedRadios.forEach(r => {
            const pos = parseInt(r.dataset.position) - 1;
            selectedOptions[pos] = r.value;
          });
          
          variantRadios.forEach(radio => {
            const pos = parseInt(radio.dataset.position) - 1;
            const hypotheticalOptions = [...selectedOptions];
            hypotheticalOptions[pos] = radio.value;

            const matchedVariant = variants.find(v => {
              return v.options.every((opt, index) => opt === hypotheticalOptions[index]);
            });

            const isAvailable = matchedVariant ? matchedVariant.available : false;
            const label = radio.nextElementSibling;

            if (!isAvailable) {
              label.classList.add('is-unavailable');
            } else {
              label.classList.remove('is-unavailable');
            }
          });
        }

        variantRadios.forEach(radio => {
          radio.addEventListener('change', function() {
            const form = this.closest('form');
            const checkedRadios = form.querySelectorAll('[data-variant-option]:checked');
            const selectedOptions = Array.from(checkedRadios).map(r => r.value);
            
            const matchedVariant = variants.find(v => {
              return v.options.every((opt, index) => opt === selectedOptions[index]);
            });

            if (matchedVariant) {
              variantIdInput.value = matchedVariant.id;
              
              const url = new URL(window.location);
              url.searchParams.set('variant', matchedVariant.id);
              window.history.replaceState({}, '', url);

              const featuredMediaId = matchedVariant.featured_media ? matchedVariant.featured_media.id : (matchedVariant.featured_image ? matchedVariant.featured_image.id : null);
              if (featuredMediaId) {
                const targetBtn = document.querySelector(`.product-media__thumbnail-btn[data-media-id="${featuredMediaId}"]`);
                if (targetBtn) {
                  targetBtn.click();
                } else {
                  const targetImg = document.querySelector(`.product-media__item[data-media-id="${featuredMediaId}"]`);
                  if (targetImg && !targetImg.classList.contains('is-active')) {
                    document.querySelectorAll('.product-media__thumbnail-btn').forEach(t => t.classList.remove('is-active'));
                    document.querySelectorAll('.product-media__item').forEach(img => img.classList.remove('is-active'));
                    targetImg.classList.add('is-active');
                  }
                }
              }

              if (addToCartBtn) {
                if (matchedVariant.available) {
                  addToCartBtn.disabled = false;
                  addToCartBtn.textContent = 'Comprar';
                  if (inventories && inventories[matchedVariant.id]) {
                    const inv = inventories[matchedVariant.id];
                    if (inv.inventory_management === 'shopify' && inv.inventory_policy === 'deny') {
                      qtyInput.setAttribute('max', inv.inventory_quantity);
                      if (parseInt(qtyInput.value, 10) > inv.inventory_quantity) {
                        qtyInput.value = Math.max(1, inv.inventory_quantity);
                      }
                    } else {
                      qtyInput.removeAttribute('max');
                    }
                  } else {
                    qtyInput.removeAttribute('max');
                  }
                } else {
                  addToCartBtn.disabled = true;
                  addToCartBtn.textContent = 'Esgotado';
                  qtyInput.removeAttribute('max');
                }
              }
            } else {
              if (addToCartBtn) {
                addToCartBtn.disabled = true;
                addToCartBtn.textContent = 'Indisponível';
              }
            }
            
            updateVariantAvailability();
          });
        });

        // Initialize availability state on load
        updateVariantAvailability();
        
        // Also initialize Add to Cart button state on load
        const initialChecked = document.querySelectorAll('[data-variant-option]:checked');
        const initialSelected = Array.from(initialChecked).map(r => r.value);
        const initialVariant = variants.find(v => {
          return v.options.every((opt, index) => opt === initialSelected[index]);
        });
        if (initialVariant) {
          const featuredMediaId = initialVariant.featured_media ? initialVariant.featured_media.id : (initialVariant.featured_image ? initialVariant.featured_image.id : null);
          if (featuredMediaId) {
            const targetBtn = document.querySelector(`.product-media__thumbnail-btn[data-media-id="${featuredMediaId}"]`);
            if (targetBtn) {
              targetBtn.click();
            } else {
              const targetImg = document.querySelector(`.product-media__item[data-media-id="${featuredMediaId}"]`);
              if (targetImg && !targetImg.classList.contains('is-active')) {
                document.querySelectorAll('.product-media__thumbnail-btn').forEach(t => t.classList.remove('is-active'));
                document.querySelectorAll('.product-media__item').forEach(img => img.classList.remove('is-active'));
                targetImg.classList.add('is-active');
              }
            }
          }

          if (addToCartBtn && !initialVariant.available) {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = 'Esgotado';
          }
        }
      } catch (e) {
        console.error('Error parsing variants JSON', e);
      }
    }

    // 4. Add to cart form logic
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var submitBtn = form.querySelector('[name="add"]');
      if (submitBtn) {
        submitBtn.setAttribute('disabled', 'disabled');
        submitBtn.textContent = 'Adicionando...';
      }

      var formData = new FormData(form);
      var body = {
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity'), 10) || 1,
        sections: [],
        sections_url: window.location.pathname
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Erro ao adicionar ao carrinho');
        return res.json();
      })
      .then(function () {
        return fetch(window.location.href);
      })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newDrawer = doc.querySelector('[data-cart-drawer]');
        var currentDrawer = document.querySelector('[data-cart-drawer]');
        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
          var closeBtn = currentDrawer.querySelector('[data-cart-close]');
          if (closeBtn) {
            closeBtn.addEventListener('click', function (ev) {
              ev.preventDefault();
              if (window.closeCart) window.closeCart();
            });
          }
        }

        var newBubble = doc.querySelector('.site-header__cart-count');
        var currentCart = document.querySelector('.site-header__cart');
        if (currentCart) {
          var currentBubble = currentCart.querySelector('.site-header__cart-count');
          if (newBubble) {
            if (currentBubble) {
              currentBubble.outerHTML = newBubble.outerHTML;
            } else {
              currentCart.insertAdjacentHTML('afterbegin', newBubble.outerHTML);
            }
          } else if (currentBubble) {
            currentBubble.remove();
          }
        }

        if (window.openCart) window.openCart();
      })
      .catch(function (err) {
        console.error('Erro ao adicionar ao carrinho:', err);
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
          submitBtn.textContent = 'Comprar';
        }
      });
    });

    // Shipping calculator is handled by the snippet's JS
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotional-banner-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const grids = document.querySelectorAll('.promo-banner-products__grid');
    
    grids.forEach(grid => {
      const slides = grid.querySelectorAll('.promo-banner-products__slide');
      if (slides.length <= 2) return; // Don't auto-scroll if 2 or fewer items
      
      let isPaused = false;
      let scrollInterval;
      
      const startScroll = () => {
        scrollInterval = setInterval(() => {
          if (isPaused) return;
          
          const maxScroll = grid.scrollWidth - grid.clientWidth;
          
          // se faltar menos de 5px pro final, resetar pro inicio
          if (grid.scrollLeft >= maxScroll - 5) {
            grid.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            const itemWidth = slides[0].offsetWidth;
            const gap = parseFloat(getComputedStyle(grid).gap) || 0;
            grid.scrollBy({ left: itemWidth + gap, behavior: 'smooth' });
          }
        }, 3000);
      };
      
      startScroll();
      
      // Allow user to interact without it jumping away
      grid.addEventListener('mouseenter', () => isPaused = true);
      grid.addEventListener('mouseleave', () => isPaused = false);
      grid.addEventListener('touchstart', () => isPaused = true, {passive: true});
      grid.addEventListener('touchend', () => {
        setTimeout(() => isPaused = false, 3000);
      }, {passive: true});
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
class SearchResults extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('popstate', this.onPopState.bind(this));
  }

  onPopState() {
    this.fetchPage(window.location.pathname + window.location.search, false);
  }

  async fetchPage(url, updateHistory = true) {
    this.classList.add('is-loading');

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network error');

      const htmlText = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const newResults = doc.querySelector('search-results');

      if (newResults) {
        this.innerHTML = newResults.innerHTML;
      }

      if (doc.title) {
        document.title = doc.title;
      }

      if (updateHistory) {
        history.pushState({ url }, '', url);
      }
    } catch (error) {
      console.error('Error fetching search page:', error);
      window.location.href = url;
    } finally {
      this.classList.remove('is-loading');
    }
  }
}

if (!customElements.get('search-results')) {
  customElements.define('search-results', SearchResults);
}

class CustomSelect extends HTMLElement {
  constructor() {
    super();
    this.valueText = this.querySelector('.custom-select__value');
    this.options = this.querySelectorAll('.custom-select__option');
    this.isOpen = false;
    this.paramName = this.dataset.param || 'sort_by';

    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.toggle);
    this.options.forEach(option => option.addEventListener('click', this.onOptionClick));
    document.addEventListener('click', this.close);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.toggle);
    this.options.forEach(option => option.removeEventListener('click', this.onOptionClick));
    document.removeEventListener('click', this.close);
  }

  toggle(event) {
    if (event.target.closest('.custom-select__option')) return;
    event.stopPropagation();
    this.isOpen = !this.isOpen;
    this.classList.toggle('is-open', this.isOpen);
  }

  close(event) {
    if (this.isOpen && !this.contains(event.target)) {
      this.isOpen = false;
      this.classList.remove('is-open');
    }
  }

  onOptionClick(event) {
    event.stopPropagation();
    const value = event.currentTarget.dataset.value;
    const text = event.currentTarget.textContent;

    this.valueText.textContent = text;
    this.options.forEach(option => option.classList.remove('is-selected'));
    event.currentTarget.classList.add('is-selected');
    this.classList.remove('is-open');
    this.isOpen = false;

    if (this.paramName === 'sort_by') {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.set('type', 'product');

      const results = document.querySelector('search-results');
      if (results && typeof results.fetchPage === 'function') {
        results.fetchPage(url.toString());
      } else {
        window.location.href = url.toString();
      }
    }
  }
}

if (!customElements.get('custom-select')) {
  customElements.define('custom-select', CustomSelect);
}

  } catch(e) { console.error(e); }
})();
})();
